import { AxiosResponse } from 'axios'

export enum AppStatus {
  IDLE,
  PENDING,
  ERROR,
  FETCHING_QUESTIONS,
  SUBMITTING_SIGNUP,
  SUBMITTING_LOGIN,
  SUBMITTING_UNREGISTER,
  SUBMITTING_CONFIRM,
  SUBMITTING_SIGNOUT,
  SUBMITTING_RECOVER,
  SUBMITTING_RESET,
}

export enum RequestActionType {
  PENDING = 'requestPending',
  SUCCESS = 'RequestSuccess',
  FAILURE = 'requestFailure',
}

export type RequestState = {
  status: AppStatus
  errorMessage: undefined | string
}

export type ResponseMeta = {
  message: string
  status_code: string
  access_token?: string
  refresh_token?: string
}

export type APIResponse<T = unknown> = AxiosResponse<T> & { meta?: ResponseMeta }

export type PaginatedResult<T> = AxiosResponse<T> & {
  data: {
    count: number
    next: string | null
    previous: string | null
    results: T[]
  }
}
